import request from '@/utils/request';

const PATH = '/business';

export const checkCertificate = () => request({
  url: `${PATH}/certificate/check`,
  method: 'get',
});

export const getCertificateLink = () => request({
  url: `${PATH}/certificate/link`,
  method: 'get',
});
